'use client';

import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey('96e7496efd0f026ab89be98b3bc1412eTz03Mzg0NixFPTE3MjUxNDQyNTEwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');

export default function MuiXLicense() {
  return null;
}